import { createDremioService, DremioServiceSymbol, DremioServiceName, optionsSchema } from './dremio';
import { createDatasetClient, DatasetClientSymbol } from './data';
import { LifetimeType, ContainerValueType } from './ServiceContainer/constants';
import { createHttpTransportCacheService, HttpTransportCacheServiceSymbol } from './cache';

export const ServiceSetupConfigs = [
    {
        id: DremioServiceSymbol,
        value: createDremioService,
        config: {
            type: ContainerValueType.FACTORY,
            lifetime: LifetimeType.TRANSIENT
        },
        meta: {
            name: DremioServiceName,
            schema: optionsSchema
        }
    },
    {
        id: HttpTransportCacheServiceSymbol,
        value: createHttpTransportCacheService,
        config: {
            type: ContainerValueType.FACTORY,
            lifetime: LifetimeType.SINGLETON
        }
    },
    {
        id: DatasetClientSymbol,
        value: createDatasetClient,
        config: {
            type: ContainerValueType.FACTORY,
            lifetime: LifetimeType.TRANSIENT
        }
    }
];
